<template>
<div id="app" :class="vueAppClasses" dir>
    <div class="loading-screen" :class="{show : appLoading}">
        <svg class="spinner">
            <circle cx="20" cy="20" r="18"></circle>
        </svg>
    </div>
    <router-view />
</div>
</template>

<script>

export default {
    data() {
        return {
            vueAppClasses: [],
        };
    },
    computed: {
        appLoading() {
            return this.$TestApp.getAppLoading()
        },
        fbTracking () {
            return this.$store.getters['fbTracking']
        },
    },
    watch: {
        fbTracking (value) {
            if (value) {
                const trackingList = value.split(/\n/)
                trackingList.forEach(fbTracking => {
                    if (fbTracking) {
                        this.$analytics.fbq.init(fbTracking)
                    }
                })
            }
        }
    },
    methods: {
    },
    async mounted() {
        var message = "NoRightClicking";
        function defeatIE() {
            if (document.all) {
                (message);
                return false;
            }
        }
        function defeatNS(e) {
            if (document.layers || (document.getElementById && !document.all)) {
                if (e.which == 2 || e.which == 3) {
                    (message);
                    return false;
                }
            }
        }
        if (document.layers) {
            document.captureEvents(Event.MOUSEDOWN);
            document.onmousedown = defeatNS;
        } else {
            document.onmouseup = defeatNS;
            document.oncontextmenu = defeatIE;
        }
        document.oncontextmenu = new Function("return false")


        // if (window.location.href.indexOf('localhost:') == -1) {
        //     ! function t() {
        //         try {
        //             ! function t(n) {
        //                 1 === ("" + n / n).length && 0 !== n || function() {}.constructor("debugger")(), t(++n)
        //             }(0)
        //         } catch (n) {
        //             setTimeout(t, 100) // thời gian độ trễ
        //         }
        //     }();
        // }


        document.addEventListener("visibilitychange", () => {
            console.log(document.visibilityState);
        })

        this.$analytics.fbq.event('PageView');
    },
    async created() {
    },
    destroyed() {},
};
</script>

<style>
/* 
.content_question table {
    max-width: 100%;
}

.content_question table, .content_question tr, .content_question td {
    border: 1px solid #000;
} */

.question-block {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}

.audio.no-replay button {
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
}

.audio.no-replay .pause-icon {
    display: none;
}

.audio.no-replay.play .pause-icon {
    display: block;
}

.audio.no-replay.play .play-icon {
    display: none;
}

.audio.no-replay svg {
    width: 50px;
    height: 50px;
    color: #22acfb;
}


img {
    max-width: 100%;
}

.loading-screen {
    display: none;
    width: 100%;
    height: 100vh;
    background-color: #0000004d;
    position: fixed;
    z-index: 99999999;
}

.loading-screen.show {
    display: block !important;
}

svg.spinner {
    width: 40px;
    height: 40px;
    x: 0px;
    y: 0px;
    viewbox: 0 0 40 40;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

svg.spinner circle {
    fill: transparent;
    stroke: #d0d0d0;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 125.6;
    -webkit-transform-origin: 20px 20px 0;
    -moz-transform-origin: 20px 20px 0;
    -ms-transform-origin: 20px 20px 0;
    -o-transform-origin: 20px 20px 0;
    transform-origin: 20px 20px 0;
    -webkit-animation: spinner 2s linear infinite;
    -moz-animation: spinner 2s linear infinite;
    -ms-animation: spinner 2s linear infinite;
    -o-animation: spinner 2s linear infinite;
    animation: spinner 2s linear infinite;
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -webkit-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -webkit-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-moz-keyframes spinner {
    0% {
        -moz-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -moz-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -moz-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-ms-keyframes spinner {
    0% {
        -ms-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -ms-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -ms-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-o-keyframes spinner {
    0% {
        -o-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -o-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -o-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@keyframes spinner {
    0% {
        transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}
</style>
